var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 50,
    height: 50,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24 1 C 18.495178 1 14 5.4951777 14 11 L 14 18.5 L 14.042969 18.5 C 10.366894 21.434776 8 25.944099 8 31 C 8 39.818787 15.181206 47 24 47 C 32.818794 47 40 39.818787 40 31 C 40 25.944099 37.633106 21.434776 33.957031 18.5 L 34 18.5 L 34 11 C 34 5.4951777 29.504822 1 24 1 z M 24 4 C 27.883178 4 31 7.1168223 31 11 L 31 16.636719 C 28.881922 15.599587 26.511904 15 24 15 C 21.488096 15 19.118078 15.599587 17 16.636719 L 17 11 C 17 7.1168223 20.116822 4 24 4 z M 24 24 C 26.761 24 29 26.239 29 29 C 29 31.049 27.764 32.806125 26 33.578125 L 26 37 C 26 38.105 25.105 39 24 39 C 22.895 39 22 38.105 22 37 L 22 33.578125 C 20.236 32.806125 19 31.049 19 29 C 19 26.239 21.239 24 24 24 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7702fca75bf64698a293577f7c2bce5e.svg";
export { ForwardRef as ReactComponent };